import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'

export const Lifestyle = () => {
  const blockId = CMS_BLOCK.HOME_LIFESTYLE

  return (
    <Container>
      <CmsBlock
        id={blockId}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <div>
      <h2>Lifestyle Products For Everyone</h2>
      <div className='categories'>
        <div>
          <p> Mobility </p>
          <a href='/'>
            <div className='button'>
              View Products
            </div>
          </a>
        </div>
        <div>
          <p> Bladder control </p>
          <a href='/'>
            <div className='button'>
              View Products
            </div>
          </a>
        </div>
        <div>
          <p> Nutritional </p>
          <a href='/'>
            <div className='button'>
              View Products
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}
